import React from "react";
import clsx from "clsx";

import { Collapse, Toggle, Skeleton } from "components";
import { useLoader } from "hooks";

import styles from "./uwComponent.module.scss";

type PropsType = {
	header: string;
	recordsCount?: any;
	loading?: boolean;
	children?: any;
	experianReport?: boolean;
	className?: string;
	collapseClassName?: string;
	collapseHeaderContentClassName?: string;
	collapseBodyClassName?: string;
	defaultToggled?: boolean;
	showToggle?: boolean;
};

const UwCollapseSection = ({
	header,
	recordsCount = 0,
	loading,
	children,
	experianReport = false,
	className,
	collapseClassName,
	collapseHeaderContentClassName,
	collapseBodyClassName,
	defaultToggled,
	showToggle = true,
}: PropsType) => {
	const HeaderContent = ({ className }) => {
		const isExperianReport = experianReport ? null : (
			<span>
				:
				<span className={className}>
					{recordsCount} Record(s) Found
				</span>
			</span>
		);

		return (
			<div
				className={clsx(
					styles.collapseHeaderContent,
					collapseHeaderContentClassName,
				)}
			>
				{header}
				{isExperianReport}
			</div>
		);
	};

	const CollapseHeader = ({ toggle, isToggled }) =>
		!showToggle || recordsCount === 0 ? (
			<HeaderContent className={styles.labelSuccess} />
		) : (
			<Toggle
				isToggled={isToggled}
				className={styles.collapseHeader}
				onClick={toggle}
			>
				<HeaderContent className={styles.labelDanger} />
			</Toggle>
		);

	const CollapseBody = () => (
		<div
			className={clsx(
				className,
				styles.collapseBody,
				collapseBodyClassName,
			)}
		>
			{children}
		</div>
	);

	const Loader = useLoader(loading);

	return (
		<Loader
			skeleton={<Skeleton height="50px" margin="30px 0" />}
			component={
				<Collapse
					className={clsx(styles.collapseWrapper, collapseClassName)}
					header={CollapseHeader}
					body={CollapseBody}
					bodyClassName={styles.body}
					defaultToggled={defaultToggled}
				/>
			}
		/>
	);
};

export default UwCollapseSection;
